/* eslint-disable */
const {VjsUtility} = window;
(function () {
    const f = function () {};
    if (!window.console) {
        window.console = {
            log: f,
            info: f,
            warn: f,
            debug: f,
            error: f,
        };
    }
})();

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = `${number}`.replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
    const dec = typeof dec_point === 'undefined' ? '.' : dec_point;
    let s = '';
    const toFixedFix = function (n, prec) {
        const k = 10 ** prec;
        return `${Math.round(n * k) / k}`;
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

$.urlParam = function (name) {
    const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(window.location.href);
    if (results == null) {
        return null;
    }
    return decodeURI(results[1]) || 0;
};

$.fn.serializeControls = function () {
    const data = {};

    function buildInputObject(arr, val) {
        if (arr.length < 1) {
            return val;
        }
        let objkey = arr[0];
        if (objkey.slice(-1) == ']') {
            objkey = objkey.slice(0, -1);
        }
        const result = {};
        if (arr.length == 1) {
            result[objkey] = val;
        } else {
            arr.shift();
            const nestedVal = buildInputObject(arr, val);
            result[objkey] = nestedVal;
        }
        return result;
    }

    $.each(this.serializeArray(), function () {
        console.log('THIS:', this);
        const val = this.value;
        const c = this.name.split('[');
        const a = buildInputObject(c, val);
        $.extend(true, data, a);
    });

    return data;
};

if (typeof jQuery.when.all === 'undefined') {
    jQuery.when.all = function (deferreds) {
        return $.Deferred((def) => {
            $.when.apply(jQuery, deferreds).then(
                function () {
                    console.log('here resolve');
                    def.resolveWith(this, [Array.prototype.slice.call(arguments)]);
                },
                function () {
                    console.log('here reject');
                    def.rejectWith(this, [Array.prototype.slice.call(arguments)]);
                }
            );
        });
    };
}

var VjsAdmin = (function () {
    let initialized = false;

    const assets_root = $('meta[property="assets_root"]').attr('content');
    const static_images_path = $('meta[property="static_images_path"]').attr('content');
    const site_mode = $('meta[property="site_mode"]').attr('content');
    const user_permissions = JSON.parse(atob($('meta[property="user_permissions"]').attr('content')));
    let isPageBeingRefreshed = false;

    const pNotify_options_permissions = {
        animate: {
            animate: true,
            in_class: 'bounceInLeft',
            out_class: 'bounceOutRight',
        },
        in_class: 'zoomInLeft',
        out_class: 'zoomOutRight',
        addclass: 'stack-bottomright',
        buttons: {
            sticker: false,
        },
        stack: { dir1: 'up', dir2: 'left', push: 'bottom' },
        after_init(notice) {
            notice.attention('rubberBand');
        },
    };

    function convertDateRow(row, format, timeago_array = []) {
        // we're getting a UTC date from the DB... need to convert it to the users timezone...?
        Object.keys(row).forEach((key) => {
            if (
                key.indexOf('date_') >= 0 ||
                key.indexOf('_date') >= 0 ||
                key.indexOf('archived_at') >= 0 ||
                key.indexOf('created_at') >= 0 ||
                key.indexOf('updated_at') >= 0
            ) {
                row[key] = VjsAdmin.convertDate(row[key], format, $.inArray(key, timeago_array) != -1);
            }
        });
        return row;
    }

    function convertDate(date, format, timeago) {
        timeago = typeof timeago !== 'undefined' ? timeago : false;
        if (date != null) {
            if (date.length > 10) {
                var momentDate = moment.utc(date).tz(moment.tz.guess());
                if (timeago) {
                    date = `<time title='${momentDate.format('MMMM Do YYYY, h:mm:ss a')}'>${momentDate.fromNow()}</time>`;
                } else {
                    date = `<time title='${momentDate.format('MMMM Do YYYY, h:mm:ss a')}'>${momentDate.format(format)}</time>`;
                }
            } else {
                // if date length <= 10, it's just a date, no time (like MM/DD/YYYY), so don't adjust for timezone!
                var momentDate = moment.utc(date);
                if (timeago) {
                    date = `<time title='${momentDate.format('MMMM Do YYYY')}'>${momentDate.fromNow()}</time>`;
                } else {
                    date = `<time title='${momentDate.format('MMMM Do YYYY')}'>${momentDate.format('MM/DD/YYYY')}</time>`;
                }
            }
        }
        return date;
    }

    const secondsToHoursMinutes = function (seconds) {
        if (seconds > 0) {
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.round((seconds - hours * 3600) / 60);
            if (hours < 10) {
                hours = `0${hours}`;
            }
            if (minutes < 10) {
                minutes = `0${minutes}`;
            }

            const duration = `${hours}:${minutes}`;

            return `<span title="${seconds} seconds">${duration}</span>`;
        }
        return 0;
    };

    /**
     * Custom sorter for bootstrap table columns with dates
     * */
    function dateSorter(a, b) {
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
        return 0;
    }

    const init = function () {
        if (initialized) return;
        initialized = true;

        $(document).on('click', '.btn-sidebar[data-toggle="sidebar"]', () => {
            $('.app-sidebar').toggleClass('show');
        });

        $(document).on('click', '.sidebar-nav-group', () => {
            $('.app-sidebar').addClass('show');
        });

        $(window).on('beforeunload', (e) => {
            isPageBeingRefreshed = true;
            NProgress.start();
            NProgress.set(1.0);
        });

        // `pagehide` replaces the deprecated `unload` event, which modern
        // browsers block via Permissions-Policy (logs a violation and never
        // fires). `pagehide` fires reliably on navigation and is bfcache-safe.
        $(window).on('pagehide', () => {
            NProgress.done(true);
        });

        // disable keypresses in datetimepicker input fields, to prevent people from
        // trying to type in them. Force them to use the picker
        $(document).on('keydown', '.datetimepicker input', (e) => {
            e.preventDefault();
        });
        $(document).on('keydown', '.timepicker input', (e) => {
            e.preventDefault();
        });

        window.onerror = function (message, url, linenumber, columnnumber, error) {
            if (!isPageBeingRefreshed) {
                if (error != null && linenumber != 0) {
                    if (typeof ga === 'function') {
                        ga(
                            'send',
                            'event',
                            'javascript-error',
                            `JavaScript error: ${message} on line ${linenumber} column ${columnnumber} for ${url}`
                        );
                    }
                }
                if (site_mode == 'development') {
                    console.log('Javascript Error:', message, url, linenumber, columnnumber, error);
                    if (error != null && linenumber != 0) {
                        alert(`JavaScript error: ${message} on line ${linenumber} column ${columnnumber} for ${url}`);
                    }
                }
            } else {
                console.log('page is being refreshed!! Supressing errors!');
            }
        };

        $(document).ajaxError((event, jqxhr, settings, thrownError) => {
            if (!isPageBeingRefreshed) {
                if (thrownError != 'abort') {
                    // ignore abort errors
                    if (typeof ga === 'function') {
                        ga('send', 'event', 'ajax-error', `Javascript AJAX error: \`${thrownError}\` for ${settings.url}`);
                    }
                    if (site_mode == 'development') {
                        console.log(`AJAX ERROR: ${thrownError}`, event, jqxhr, settings);
                        alert(`Javascript AJAX error: \`${thrownError}\` for ${settings.url}`);
                    }
                }
            } else {
                console.log('page is being refreshed!! Supressing AJAX errors!');
            }
        });

        $('.vjsadmin-form').on('submit', function () {
            $(this).find('button, input[type=submit]').prop('disabled', true);
            $('.app').addClass('light-blur');
            $('#ajax-progress-indicator').fadeIn();
        });

        $('.hover-letters').each(function () {
            const el = $(this);
            const characters = el.text().split('');
            el.empty();
            $.each(characters, (i, character) => {
                if (character == ' ') {
                    el.append(' ');
                } else {
                    el.append(`<span>${character}</span`);
                }
            });
        });

        $('body').on('click', '.click-reveal', function (e) {
            e.preventDefault();
            $(this).replaceWith($(this).attr('data-value'));
        });

        $('time[data-date-format]').each(function () {
            const el = $(this);
            const utc_datetime = el.attr('data-utc-datetime');
            const date_format = el.attr('data-date-format');
            if (utc_datetime != '') {
                let dt = moment.utc(utc_datetime);
                if (utc_datetime.length > 10) {
                    dt = dt.tz(moment.tz.guess());
                }

                if (date_format == 'timeago') {
                    el.text(dt.fromNow());
                } else {
                    el.text(dt.format(date_format));
                }
                el.attr('title', dt.format('MMMM Do YYYY, h:mm:ss a'));
            } else {
                el.text('--');
            }
            $(this).fadeIn();
        });

        // test for sticky top warning
        (function () {
            const $message = $('.sticky-top.warning > .warning-message');
            if ($message.length === 0) return;

            // there is a warning, show the message
            $message.show();
        })();
    };

    const initMe = function (children) {
        // make sure VJS is initialized first
        if (!initialized) {
            VjsAdmin.init();
        }

        // if children is an array, init each child
        if (Array.isArray(children)) {
            $.each(children, (i, child) => {
                if (typeof child.init === 'function') {
                    child.init();
                }
            });
        } else if (typeof children === 'object') {
            const child = children;
            if (typeof child.init === 'function') {
                child.init();
            }
        }
    };

    const getUserPermissions = function () {
        return user_permissions;
    };

    const hasPermission = function (route_name) {
        return typeof user_permissions[route_name] !== 'undefined';
    };

    const getAssetsRoot = function () {
        return assets_root;
    };

    const getStaticImagesPath = function () {
        return static_images_path;
    };

    const debounce = function (func, wait, immediate) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    const initDateRangePickers = function (parent, removeWeekends) {
        $(parent)
            .find('.datetimepicker')
            .each(function () {
                const original_date_value = $(this).find('input').attr('value');
                let default_date = new Date();
                if (original_date_value && original_date_value != '') {
                    default_date = new Date($(this).find('input').attr('value'));
                }

                $(this).datetimepicker({
                    daysOfWeekDisabled: removeWeekends ? [0, 6] : [],
                    defaultDate: default_date,
                    useCurrent: false,
                    format: 'MM/DD/YYYY', // 'MM/DD/YYYY HH:mm',
                    maxDate: moment.utc('2038-01-19 03:14:06'), // prevent errors from y2k38 bug
                    icons: {
                        date: 'fa fa-calendar',
                        previous: 'fa fa-hand-o-left',
                        next: 'fa fa-hand-o-right',
                    },
                });
                $(this).find('input').val(original_date_value);
            });

        $(parent)
            .find('.datetimepicker-from')
            .on('dp.change', (e) => {
                $(parent).find('.datetimepicker-to').data('DateTimePicker').minDate(e.date);
            });
        $(parent)
            .find('.datetimepicker-to')
            .on('dp.change', (e) => {
                $(parent).find('.datetimepicker-from').data('DateTimePicker').maxDate(e.date);
            });

        $(parent)
            .find('.datetimepicker-from')
            .on('click', 'input', () => {
                $(parent).find('.datetimepicker-from').data('DateTimePicker').show();
            });
        $(parent)
            .find('.datetimepicker-to')
            .on('click', 'input', () => {
                $(parent).find('.datetimepicker-to').data('DateTimePicker').show();
            });
    };

    /**
     *   Copy to clipboard
     */
    const copyToClipboard = function (text) {
        const $temp = $('<input>');
        $('body').append($temp);
        $temp.val(text).select();
        document.execCommand('copy');
        $temp.remove();
    };

    // Start processing
    const startProcessing = function () {
        $('body').css('cursor', 'wait');
        $('.app').addClass('light-blur');
        $('#ajax-progress-indicator').fadeIn();
    };

    const stopProcessing = function () {
        $('body').css('cursor', 'default');
        $('.app').removeClass('light-blur');
        $('#ajax-progress-indicator').fadeOut();
    };

    const platformIdToPlatformName = (platformId) => {
        if (platformId == 1) {
            return 'VirtualJobShadow.com';
        }
        if (platformId == 2) {
            return 'VJSJunior.com';
        }
    };

    return {
        dateSorter,
        convertDateRow,
        convertDate,
        secondsToHoursMinutes,
        getUserPermissions,
        hasPermission,
        getAssetsRoot,
        getStaticImagesPath,
        pNotify_options_permissions,
        debounce,
        initDateRangePickers,
        copyToClipboard,
        init,
        initMe,
        startProcessing,
        stopProcessing,
        platformIdToPlatformName,
    };
})();
$(document).ready(() => {
    VjsAdmin.init();

    setTimeout(() => {
        $('head').addClass('vjsTestingJsLoaded');
    }, 300);

    if (typeof loadMe === 'function') {
        loadMe();
    }
});
